


<div class="container">

  <h1>الاعاقات</h1>

  <!-- MAIN DROPDOWN -->
  <label>الاعاقات الرئيسية</label>
  <select [(ngModel)]="selectedMain" (change)="onMainChange()">
    <option value="">-- Select Main --</option>
    <option *ngFor="let m of mainList" [value]="m.key">
      {{ m.name }}
    </option>
  </select>

  <!-- SUB DROPDOWN -->
  <label>الاعاقات الفرعية</label>
  <select [(ngModel)]="selectedSub" (change)="onSubChange()">
    <option value="">-- Select Sub --</option>
    <option *ngFor="let s of subList" [value]="s.key">
      {{ s.name }}
    </option>
  </select>

  <!-- LOADING -->
  <div class="overlay-wrapper" *ngIf="loading">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <!-- GRID LIST (replaces table) -->
  <div *ngIf="subSubList.length > 0" class="items-container">

    <div class="card" *ngFor="let item of subSubList">

      <div class="card-content">

        <!-- INFO -->
        <div class="info">
          <div class="name">{{ item.name }}</div>
          <div class="code">{{ item.mainCode }}</div>
        </div>

        <!-- TOGGLE -->
        <label class="switch">
          <input
            type="checkbox"
            [(ngModel)]="item.isActive"
          />
          <span class="slider"></span>
        </label>

      </div>



    </div>

  </div>

  <!-- EMPTY -->
  <div *ngIf="!loading && subSubList.length === 0" class="empty">
    لا توجد بيانات
  </div>

<!-- UPDATE ALL -->
<button
  (click)="openConfirm()"
  [disabled]="subSubList.length === 0"
>
  تحديث
</button>

<!-- CONFIRM MODAL -->
<div class="modal-overlay" *ngIf="showConfirm">
  <div class="modal-box">

    <h3>تأكيد العملية</h3>
    <p>هل أنت متأكد أنك تريد التحديث؟</p>

    <div class="modal-actions">
      <button class="btn cancel" (click)="showConfirm = false">
        لا
      </button>
      <button class="btn confirm" (click)="confirmUpdate()">
        نعم
      </button>
    </div>

  </div>
</div>